export const getAllCategories = (state) => state.category.categories;
export const getIsLoading = (state) => state.category.isLoading;
